export default "__VITE_ASSET__DSpDLrwD__"